<template>
    <v-layout align-center fill-height justify-center row wrap>
        <v-flex :key="index" class="text-xs-center icono-pregunta" v-for="(pregunta,index) in preguntas" xs6>
            <img :alt="'pregunta '+index" :src="imagenes[index]"
                 @click="abrirModal(index)" class="animated fadeIn hvr hvr-scale actividad-img" v-if="preguntasContestadas >= index">
            <img :src="correctas[index]? imgBienBot: imgMalBot" class="retroalim-bot"
                 v-if="preguntasContestadas > index">
        </v-flex>
        <v-dialog v-model="modal" width="500px">
            <v-card>
                <boton-cerrar-modal-app :titulo="'Pregunta '+(actual+1)" @cerrar="modal=false"></boton-cerrar-modal-app>
                <v-card-text>{{preguntas[actual].enunciado}}</v-card-text>
                <v-card-actions v-if="!retroalim">
                    <v-layout justify-center row wrap>
                        <v-flex class="text-xs-center" xs6>
                            <v-btn @click="validarRespuesta(true)">Verdadero</v-btn>
                        </v-flex>
                        <v-flex class="text-xs-center" xs6>
                            <v-btn @click="validarRespuesta(false)">Falso</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
                <v-card-text :class="retroalimClass" class="text-xs-center" v-else>{{retroalimText}}</v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>


    export default {

        props: ['preguntas'],
        data() {
            return {
                actual: 0,
                retroalim: false,
                retroalimText: '',
                retroalimClass: '', // bien o mal
                modal: false,
                cerrar: '',
                imagenes: [],
                correctas: [],
                imgBienBot: '',
                imgMalBot: '',
                preguntasContestadas: 0 //Contador binario
            }
        },
        created() {
            var self = this
            this.getPng('imagenes_compartidas/cerrar_blan', data => {
                self.cerrar = data
            })
            this.getPng('imagenes_compartidas/ok-bot', data => {
                self.imgBienBot = data
            })
            this.getPng('imagenes_compartidas/mal-bot', data => {
                self.imgMalBot = data
            })
            for (var i = 1; i <= this.preguntas.length; i++) {
                this.getPng('imagenes_compartidas/actividad' + i, data => {
                    self.imagenes.push(data)
                })
            }
            this.correctas = Array(this.preguntas.length).fill(false)
        },
        methods: {
            validarRespuesta(resp) {
                if (resp == this.preguntas[this.actual].respuesta) {
                    this.retroalimText = this.preguntas[this.actual].retroalimentacionBien
                    this.retroalimClass = 'bien'
                    this.correctas[this.actual] = true
                } else {
                    this.retroalimText = this.preguntas[this.actual].retroalimentacionMal
                    this.retroalimClass = 'mal'
                }
                this.retroalim = true;
                // Solo avanza hasta que reponda bien la pregunta actual (la condición es para prevenir que no avance si responde la misma pregunta varias veces)
                if (this.preguntasContestadas <= this.actual)
                    this.preguntasContestadas++

                if (this.preguntasContestadas >= this.preguntas.length) {
                    this.$emit('actividadFinalizada')
                }
            },
            abrirModal(id) {
                this.modal = true;
                this.actual = id
                this.retroalimClass = ''
                this.retroalim = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .bien {
        background-color: #BEF299
    }

    .mal {
        background-color: #FFA1A1
    }

    .cerrar {
        padding: 10px;
        padding-bottom: 0;

        img {
            width: 30px;
            padding: 5px;
            background: #004636;
            border-radius: 45px;
        }
    }

    .actividad-img {
        max-width: 50%;
        height: 15vh;
    }

    .icono-pregunta {
        position: relative;
    }

    .retroalim-bot {
        position: absolute;
        top: 0;
        left: calc(50% - 15px);
    }
</style>

